// 這是Webpack掛載起始點
import Layout from './layout.vue'
import Index from './index.vue'
import New from '../.components/new.vue'
import Show from '../.components/show.vue'

const main_router = 'driver_commission_reports'
const new_router = 'new_driver_commission_report'
const show_router = 'driver_commission_report'

const router = [
    {
        path: '',
        component: Index,
        name: 'driver_commission_reports',
        meta: {
            api_name: 'api_v1_provider_driver_commission_reports',
            breadcrumb: [main_router],
            btns: [new_router]
        }
    },
    {
        path: 'new',
        component: New,
        name: 'new_driver_commission_report',
        meta: {
            api_name: 'api_v1_provider_driver_commission_report_create',
            breadcrumb: [main_router, new_router]
        }
    },
    {
        path: ':identity',
        component: Show,
        name: 'driver_commission_report',
        meta: {
            api_name: 'api_v1_provider_driver_commission_report',
            breadcrumb: [main_router, show_router]
        }
    },
]

export default router
